import { render, staticRenderFns } from "./projectReportW.vue?vue&type=template&id=8cd32a60&scoped=true&"
import script from "./projectReportW.vue?vue&type=script&lang=js&"
export * from "./projectReportW.vue?vue&type=script&lang=js&"
import style0 from "./projectReportW.vue?vue&type=style&index=0&id=8cd32a60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd32a60",
  null
  
)

export default component.exports